<template>
	<div class="add-iCard">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="iDard.id ? $t('addIDard.edit') : $t('addIDard.add')"
			:visible.sync="dialogIDard"
			width="650px"
			top="9vh"
			@open="openDialog"
			@closed="closeDialog"
			:close-on-click-modal="false">
			<div
				class="content"
				v-loading="loadingForm"
				:element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="iDard"
					label-width="80px"
					:model="iDard">
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item :label="$t('addIDard.name')" prop="name">
								<el-input
									v-model="iDard.name"
									:placeholder="$t('addIDard.pName')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item :label="$t('addIDard.type')" prop="type">
								<el-input
									v-model="iDard.type"
									:placeholder="$t('addIDard.pType')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item :label="$t('addIDard.pdfType')" prop="pdfType">
								<el-input
									v-model="iDard.pdfType"
									:placeholder="$t('addIDard.pPdfType')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item :label="$t('addIDard.country')" prop="country">
								<el-select
									v-model="iDard.country"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									filterable
									clearable
									:placeholder="$t('addIDard.pCountry')">
									<el-option
										v-for="item in countrySet"
										:key="item.id"
										:label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item :label="$t('addIDard.content')" prop="content">
								<el-input
									v-model="iDard.content"
									type="textarea"
									:rows="4"
									readonly="readonly"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item
								:label="$t('addIDard.barcode')"
								prop="barcode"
								style="margin: 0">
								<el-checkbox-group v-model="checkSet" @change="handleChange">
									<el-checkbox
										v-for="checks in checkList"
										:key="checks.value"
										:label="checks.value"
										>{{ checks.label }}</el-checkbox
									>
								</el-checkbox-group>
							</el-form-item>
						</el-col>
					</el-row>
					<template v-if="one">
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item :label="$t('addIDard.year')" prop="year">
									<el-input
										v-model="iDard.year"
										:placeholder="$t('addIDard.pYear')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item :label="$t('addIDard.month')" prop="month">
									<el-input
										v-model="iDard.month"
										:placeholder="$t('addIDard.pMonth')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item :label="$t('addIDard.day')" prop="day">
									<el-input
										v-model="iDard.day"
										:placeholder="$t('addIDard.pDay')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</template>
					<template v-if="two">
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item :label="$t('addIDard.pdfYear')" prop="pdfYear">
									<el-input
										v-model="iDard.pdfYear"
										:placeholder="$t('addIDard.pYear')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item :label="$t('addIDard.pdfMonth')" prop="pdfMonth">
									<el-input
										v-model="iDard.pdfMonth"
										:placeholder="$t('addIDard.pMonth')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item :label="$t('addIDard.pdfDay')" prop="pdfDay">
									<el-input
										v-model="iDard.pdfDay"
										:placeholder="$t('addIDard.pDay')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</template>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button type="primary" @click="submitForm('iDard')">{{
					$t("common.definite")
				}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "AddIDard",
	props: {
		dialogIDard: Boolean,
		iDard: Object,
		countrySet: Array,
		labelPosition: {
			type: String,
			default: "top",
		},
	},
	data() {
		return {
			rules: {
				name: [
					{
						required: true,
						message: this.$t("addIDard.pName"),
						trigger: "blur",
					},
				],
				type: [
					{
						required: true,
						message: this.$t("addIDard.pType"),
						trigger: "blur",
					},
				],
				pdfType: [
					{
						required: true,
						message: this.$t("addIDard.pPdfType"),
						trigger: "blur",
					},
				],
				country: [
					{
						required: true,
						message: this.$t("addIDard.pCountry"),
						trigger: "blur",
					},
				],
				year: [
					{
						required: true,
						message: this.$t("addIDard.pYear"),
						trigger: "blur",
					},
				],
				month: [
					{
						required: true,
						message: this.$t("addIDard.pMonth"),
						trigger: "blur",
					},
				],
				day: [
					{
						required: true,
						message: this.$t("addIDard.pDay"),
						trigger: "blur",
					},
				],
				pdfYear: [
					{
						required: true,
						message: this.$t("addIDard.pYear"),
						trigger: "blur",
					},
				],
				pdfMonth: [
					{
						required: true,
						message: this.$t("addIDard.pMonth"),
						trigger: "blur",
					},
				],
				pdfDay: [
					{
						required: true,
						message: this.$t("addIDard.pDay"),
						trigger: "blur",
					},
				],
			},
			loadingForm: false,
			clear: false,
			checkSet: [],
			checkList: [
				{
					value: 1,
					label: this.$t("addIDard.ptbarcode"),
				},
				{
					value: 2,
					label: this.$t("addIDard.pdfbarcode"),
				},
			],
			one: false,
			two: false,
		};
	},
	methods: {
		handleChange(e) {
			this.one = e.indexOf(1) != -1 ? true : false;
			this.two = e.indexOf(2) != -1 ? true : false;
		},
		openDialog() {
			if (
				this.iDard.year &&
				this.iDard.year &&
				this.iDard.year &&
				this.iDard.pdfYear &&
				this.iDard.pdfMonth &&
				this.iDard.pdfDay
			) {
				this.checkSet.push(1);
				this.checkSet.push(2);
				this.one = true;
				this.two = true;
			} else if (this.iDard.year && this.iDard.year && this.iDard.year) {
				this.checkSet.push(1);
				this.one = true;
			} else if (
				this.iDard.pdfYear &&
				this.iDard.pdfMonth &&
				this.iDard.pdfDay
			) {
				this.checkSet.push(2);
				this.two = true;
			}
		},
		closeDialog() {
			if (this.iDard.id) {
				this.$toolUtil.clearForm(this.iDard);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.iDard);
				}
			}
			this.clearValidate("iDard");
			this.cancel("");
		},
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
		cancel(state) {
			this.$emit("cancel", false, state);
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.checkSet.length < 1) {
						this.$notify({
							title: this.$t("common.tip"),
							message: this.$t("addIDard.zstxm"),
							type: "warning",
						});
						return false;
					}
					this.loadingForm = true;
					let url = this.$url.IDard.insertIDard;
					let method = this.$method.post;
					if (this.iDard.id) {
						url = this.$url.IDard.updateIDard;
					}
					this.$api
						.request(url, method, this.iDard)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.clear = true;
								this.cancel(this.iDard.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.loadingForm = false;
						});
				}
			});
		},
	},
};
</script>

<style lang="scss">
.el-form-item__label {
	padding: 0;
}
.el-dialog__body {
	height: auto;
	padding: 0 20px 10px 20px;
}
.el-form-item {
	margin-bottom: 15px;
}
.el-form--label-top .el-form-item__label {
	padding: 0;
}
</style>
